import React from 'react';

type IconProps = { size?: number; className?: string };

const icon = (path: React.ReactNode, size = 20, className = '') => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {path}
  </svg>
);

export const IconDashboard = ({ size, className }: IconProps) =>
  icon(
    <>
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </>,
    size, className
  );

export const IconMail = ({ size, className }: IconProps) =>
  icon(
    <>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m2 7 10 7 10-7" />
    </>,
    size, className
  );

export const IconFileText = ({ size, className }: IconProps) =>
  icon(
    <>
      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <line x1="10" y1="9" x2="8" y2="9" />
    </>,
    size, className
  );

export const IconUsers = ({ size, className }: IconProps) =>
  icon(
    <>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </>,
    size, className
  );

export const IconZap = ({ size, className }: IconProps) =>
  icon(
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />,
    size, className
  );

export const IconSettings = ({ size, className }: IconProps) =>
  icon(
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </>,
    size, className
  );

export const IconLink = ({ size, className }: IconProps) =>
  icon(
    <>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </>,
    size, className
  );

export const IconInbox = ({ size, className }: IconProps) =>
  icon(
    <>
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </>,
    size, className
  );

export const IconGoogle = ({ size, className }: IconProps) =>
  icon(
    <>
      <path d="M21.8 10.2H12v3.8h5.6c-.5 2.5-2.7 4.3-5.6 4.3-3.4 0-6.1-2.7-6.1-6.1S8.6 6.1 12 6.1c1.5 0 2.9.5 3.9 1.4l2.8-2.8C17.1 3 14.7 2 12 2 6.5 2 2 6.5 2 12s4.5 10 10 10c5.5 0 9.7-3.9 9.7-9.7 0-.7-.1-1.4-.2-2.1h-9.5z" />
    </>,
    size, className
  );

export const IconMicrosoft = ({ size, className }: IconProps) =>
  icon(
    <>
      <rect x="2" y="2" width="9" height="9" fill="#f25022" stroke="none" />
      <rect x="13" y="2" width="9" height="9" fill="#7fba00" stroke="none" />
      <rect x="2" y="13" width="9" height="9" fill="#00a4ef" stroke="none" />
      <rect x="13" y="13" width="9" height="9" fill="#ffb900" stroke="none" />
    </>,
    size, className
  );

export const IconCheck = ({ size, className }: IconProps) =>
  icon(<polyline points="20 6 9 17 4 12" />, size, className);

export const IconArrowRight = ({ size, className }: IconProps) =>
  icon(
    <>
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </>,
    size, className
  );

export const IconLogOut = ({ size, className }: IconProps) =>
  icon(
    <>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </>,
    size, className
  );

export const IconRefresh = ({ size, className }: IconProps) =>
  icon(
    <>
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </>,
    size, className
  );

export const IconMenu = ({ size, className }: IconProps) =>
  icon(
    <>
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </>,
    size, className
  );

export const IconX = ({ size, className }: IconProps) =>
  icon(
    <>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </>,
    size, className
  );

export const IconShield = ({ size, className }: IconProps) =>
  icon(
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />,
    size, className
  );

export const IconChevronLeft = ({ size, className }: IconProps) =>
  icon(
    <polyline points="15 18 9 12 15 6" />,
    size, className
  );

export const IconHistory = ({ size, className }: IconProps) =>
  icon(
    <>
      <polyline points="12 8 12 12 14 14" />
      <path d="M3.05 11a9 9 0 1 0 .5-4" />
      <polyline points="3 3 3 7 7 7" />
    </>,
    size, className
  );
